/**
 * mutations are operations that actually mutates the state. each mutation handler gets the entire state tree as the
 * first argument, followed by additional payload arguments. mutations must be synchronous and can be recorded by
 * plugins for debugging purposes.
 * */
export default {
    /**
     * Set User
     * @param state
     * @param isLoading boolean
     */
    setLoading (state, isLoading) {
        state.isLoading = isLoading
    },

    toggleMessage (state, showMessage) {
        state.showMessage = showMessage;
    },

    setMessage (state, message) {
        state.message = message
    },

    stepCounterIncr (state) {
        ++state.stepCounter;
    }
}
